// soaToast, ported from the pre-Vue app.js — same .soa-toast markup the app.css styles.
let timer = null;

export function soaToast(title, sub = "", kind = "ok") {
  const old = document.getElementById("soaToast");
  if (old) old.remove();
  clearTimeout(timer);
  const safe = kind === "warn" ? "warn" : kind === "info" ? "info" : "ok";
  const ic = safe === "warn"
    ? '<path d="M12 9v4"/><path d="M12 17h.01"/><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>'
    : safe === "info"
      ? '<circle cx="12" cy="12" r="9"/><path d="M12 16v-4"/><path d="M12 8h.01"/>'
      : '<path d="M20 6 9 17l-5-5"/>';
  const esc = (v) => String(v == null ? "" : v).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const d = document.createElement("div");
  d.className = "soa-toast " + safe;
  d.id = "soaToast";
  d.setAttribute("role", safe === "warn" ? "alert" : "status");
  d.setAttribute("aria-live", safe === "warn" ? "assertive" : "polite");
  d.innerHTML = '<svg class="st-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ic + "</svg>"
    + "<span><b>" + esc(title) + "</b>" + (sub ? '<span class="st-sub">' + esc(sub) + "</span>" : "") + "</span>";
  document.body.appendChild(d);
  requestAnimationFrame(() => d.classList.add("on"));
  timer = setTimeout(() => {
    d.classList.remove("on");
    setTimeout(() => { if (d.parentNode) d.remove(); }, 240);
  }, 4200);
}
